export default {
  name: 'MicroBlink Mixin',
  methods: {
    toBase64(img) {
      return btoa(
        img.reduce((data, byte) => data + String.fromCharCode(byte), '')
      )
    },
    convertAllImagesToBase64(scanData) {
      if (scanData?.fullDocumentImage) {
        scanData.fullDocumentImage = this.toBase64(
          scanData?.fullDocumentImage.encodedImage
        )
      }

      if (scanData?.fullDocumentFrontImage) {
        scanData.fullDocumentFrontImage = this.toBase64(
          scanData?.fullDocumentFrontImage.encodedImage
        )
      }

      if (scanData?.fullDocumentBackImage) {
        scanData.fullDocumentBackImage = this.toBase64(
          scanData?.fullDocumentBackImage.encodedImage
        )
      }
      return scanData
    }
  }
}
